<template>
   <!-- 新增标签 -->
  <el-dialog
    :title="getAddTagInfo.title"
    :visible.sync="getAddTagInfo.show"
    width="600px"
    class="addTag-dialog"
    :before-close="handleClose">
    <div>
      <el-form label-width="80px">
        <el-form-item label="导航类型：">

        <el-radio-group @change="radioChange" v-model="radio">
          <el-radio :label="1">功能菜单</el-radio>
          <el-radio :label="0">外部链接</el-radio>
        </el-radio-group>
        </el-form-item>
        <el-form-item v-show="radio==1" label="打开位置：">

          <el-cascader
            :props="cascaderProps"
            placeholder="请选择"
            ref="cascaderTag"
            v-model="tagForm.tagCascader"
            :options="loadRightsMemusList"
            filterable></el-cascader>
        </el-form-item>
        <el-form-item v-show="radio==0" label="导航名称：">
          <el-input maxlength="10" v-model="tagForm.navigationName" placeholder="请输入打开位置"></el-input>
        </el-form-item>
        <el-form-item v-show="radio==0" label="URL：">
          <el-input maxlength="200" v-model="tagForm.navigationUrl" placeholder="http://"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="sumbit">确 定</el-button>
      <el-button @click="handleClose">取 消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
export default {
  props:['initValue'],
  data () {
    return {
      radio:1,
      cascaderShow:false,
      tagForm:{
        tagCascader:[],
        navigationName: "",
        navigationUrl: "",
      },
      cascaderProps:{
        label:"elementName",
        value:"elementId",
        children:"children",
        disabled:"disabled"
      },
      loadRightsMemusList: []
    }
  },
  watch:{
    initValue(val){
      // console.info(val,'initValue')
      this.setInitCascader(this.loadRightsMemusList)
      // this.$set(this,'loadRightsMemusList',arr)
    }
  },
  created () {
    this.$on('initfuc',(arg)=> {
      // console.log('on监听参数====',arg)  //['string',false,{name:'vue'}]
        
      this.$nextTick(()=>{
        this.handleClose()
      })
    })
  },
  beforeDestroy () {
    this.$off('initfuc')
  },
  mounted () {
    // console.info(123)
    this.loadRightsMemus()
  },
  computed:{
    // getDialogInfo(){
    //   this.dialogInfo=this.$store.getters.getAddTagInfo
    //   return this.dialogInfo
    // }
    ...mapGetters(['getAddTagInfo'])
  },
  methods: {
    ...mapActions(['setTagDialog']),
    sumbit(){
      if(this.radio){
        this.cascderChange(this.tagForm.tagCascader)
        
        this.findAllDashboardNavs(()=>{
          this.$emit("initfuc",this.tagForm)
          // console.info('12312313')
        })
      }else{
        if(!this.tagForm.navigationName){
          return this.$message.error("外部链接导航名称必填")
        }
        if(this.tagForm.navigationUrl.indexOf("http://")>-1||this.tagForm.navigationUrl.indexOf("https://")>-1){
            
          this.findAllDashboardNavs(()=>{
            this.$emit("initfuc",this.tagForm)
            // console.info('12312313')
          })
        }else{
          this.$message.error("外部链接必须有http://或https://")
        }
      }
    },
    radioChange(val){
      console.info(val)
      this.initAddForm()
      if(!val){
        this.tagForm.navigationUrl="http://"
      }
    },
    cascderChange(val){
      // console.info(val)
      let id=[...val].pop()
      let obj=null
      let _evt=(arr,id)=>{

        arr.map(item=>{

            if(id==item.elementId){
              obj=item
            }else{
              if(item.children&&item.children.length>0){
                _evt(item.children,id)
              }
            }
        })
      }
      _evt(this.loadRightsMemusList,id)
      // console.info(obj,'obj')
      if(obj){
          
        this.tagForm.navigationName=obj.elementName
        this.tagForm.navigationUrl=obj.pagePath
      }
      // this.loadRightsMemusList
    },
    initAddForm(){
      this.tagForm={
        tagCascader:[],
        navigationName: "",
        navigationUrl: "",
      }
    },
    // POST /dashboardNav/addDashboardNav新增快速导航
    findAllDashboardNavs(cb) {
      let tagCascader=[...this.tagForm.tagCascader]
      this.$axios
        .post(`/onelink.mdata.main.api/dashboardNav/addDashboardNav`, {
          // 是否外部链接 是0 否是1
          isOuter: this.radio,
          navigationName: this.tagForm.navigationName,
          navigationUrl:  this.tagForm.navigationUrl,
          menuId: this.radio?tagCascader.pop():'',
        })
        .then(res => {
          // console.info(res.data.code,'res.data.code',res)
          if(res.data.code==0){
            cb&&cb()
          }else{
            this.$message.error(res.data.errorMsg)
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // GET /loadRightsMemus加载权限系统所有的菜单
    loadRightsMemus(cb) {
      this.$axios
        .get(`/onelink.mdata.main.api/loadRightsMemus`, {
          params:{
            // 是否外部链接 是0 否是1
            // isOuter: this.radio,
            language:0
          }
        })
        .then(res => {
          if (res.data.code == 0) {
            // console.info(res,this.initValue,'this.initValue,this.initValue')
            // 转换最外层键值对，统一结构
            
            let arr=res.data.rows.map(item=>{
              item.elementName=item.productName
              item.elementId=item.productId
              item.children=item.elements
              return item
            })
            let _evt=(item)=>{
              let ftArr=item.children&&item.children.filter((ft)=>{
                if(ft.elementType<2){
                  return ft
                }
              })
              // 判断筛选出子集为空的时候，链接为空
              if((ftArr.children&&ftArr.children.length==0)||!ftArr.children){

                if(item.children&&item.children.length>0){
                  item.children.map(obj3=>{
                    if(obj3.isMainPage == 0){
                      
                      item.pagePath=item.pagePath||obj3.pagePath
                    }
                  })
                  item.pagePath=item.pagePath||item.children[0].pagePath
                }
              }
              item.children=ftArr
              return item
            }
            // 最大3层
            arr.map(item=>{
              // 过滤筛选出子集elementType小于2
              
              item=_evt(item)

              if(item.children&&item.children.length>0){
                item.children.map(obj=>{
                  obj=_evt(obj)
                  if(obj.children&&obj.children.length>0){
                      // if(obj.pagePath||obj.children){
                          
                      //   obj.pagePath=obj.pagePath||obj.children[0].pagePath
                      // }
                      // 判断跳转
                    obj.children.map(obj2=>{
                      
                      // if(obj2.children&&obj2.children.length>0){
                      //   obj2.children.map(obj3=>{
                      //     if(obj3.isMainPage == 0){
                            
                      //       obj2.pagePath=obj2.pagePath||obj3.pagePath
                      //     }
                      //   })
                      //   obj2.pagePath=obj2.pagePath||obj2.children[0].pagePath
                      // }
                      obj2=_evt(obj2)
                      obj2.children=null
                      this.$set(obj2,'disabled',false)
                    })
                  }
                })
              }
            })
            console.info(arr,'arr')
            // console.info(this.initValue,'loadRightsMemus')
            this.setInitCascader(arr)
            // console.info(this.loadRightsMemusList,'this.loadRightsMemusList')
          } else {
            this.$message.error(data.errorMsg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    
    handleClose(){
      this.initAddForm()
      this.setTagDialog({show:false})
    },
    // 根据入参设置禁用
    setInitCascader(arr){
      // 设置列表全部都不禁用
      let _initDisabled=(arr)=>{
        if(arr&&arr.length>0){
          for(let i=0;i<arr.length;i++){
            this.$set(arr[i],'disabled',false)
            if(arr[i].children&&arr[i].children.length>0){
              _initDisabled(arr[i].children)
            }
          }
        }
      }
      _initDisabled(arr)
      // initValue
      let _evt=(arr,id)=>{

        if(arr&&arr.length>0){

          for(let i=0;i<arr.length;i++){
              if(id==arr[i].elementId){
            //  console.info(id==arr[i].elementId,id,arr[i].elementId)
                // obj=item
                // arr[i].disabled=true
                this.$set(arr[i],'disabled',true)
                // console.info(arr[i],'arr[i]')
              }else{
                // 不相等时重置就只有一个禁用项
                // this.$set(arr[i],'disabled',false)
                if(arr[i].children&&arr[i].children.length>0){
                  _evt(arr[i].children,id)
                }else{
                  // 隐藏没有自己得项
                  arr[i].children=null
                }
              }
          }
        }
      }
      // 根据已有菜单设置禁用
      this.initValue&&this.initValue.map(item=>{
        _evt(arr,item.menuId)
      })
      // console.info(arr,'loadRightsMemusList')
      this.$set(this,'loadRightsMemusList',arr)
    }
  }
}
</script>
<style>
.addTag-dialog .el-dialog__header{
  padding:12px 15px;
  background: #F0F2F5;
  border-radius: 3px 3px 0 0;
  border-radius: 3px 3px 0px 0px;
}
.addTag-dialog .el-dialog__header .el-dialog__headerbtn {
    top: 12px;
}
.addTag-dialog .el-dialog__body{
  padding: 20px;
}
.addTag-dialog .el-dialog__title{
  
  font-size: 16px;
  color: #303133;
  text-align: left;
  line-height: 24px;
}
.addTag-dialog .el-dialog__footer{
  text-align: center;
  padding-bottom: 15px;
}
.addTag-dialog .el-dialog__footer .el-button{
  padding: 8px 15px;
  font-size: 12px;
  line-height: 16px;
}
.addTag-dialog .el-dialog__footer .el-button--primary{ 
  background: #2E8AF1;
  border-color: #2E8AF1;
}
.addTag-dialog .el-dialog__footer .el-button--primary:focus, .addTag-dialog .el-dialog__footer .el-button--primary:hover {
    background: #66b1ff;
    border-color: #66b1ff;
}
.addTag-dialog .el-dialog__footer .el-button--default{
  color: #606266;
}
.addTag-dialog .el-dialog__footer .el-button--default:hover,.addTag-dialog .el-dialog__footer .el-button--default:focus{
  color: #2E8AF1;
}

.addTag-dialog .el-form-item{
  font-size: 12px;
  height: 30px;
  line-height: 30px;
  margin-bottom: 15px;
}
.addTag-dialog .el-form-item__label{
  font-size: 12px;
  color:#909399;
  font-weight: normal;
  padding-right: 5px;
}
.addTag-dialog .el-form-item .el-input{
  width: 450px;
  font-size: 12px;
}
.addTag-dialog .el-form-item .el-radio__label{
  font-size: 12px;
}
.addTag-dialog .el-form-item .el-cascader{
  font-size: 12px;
}
.addTag-dialog .el-form-item .el-input__inner{
  font-size: 12px;
  width: 450px;
  height: 30px;
  line-height: 30px;
  padding-left: 10px;
}
.addTag-dialog .el-radio__input.is-checked+.el-radio__label{
  color:#2E8AF1
}
.addTag-dialog .el-radio__input.is-checked .el-radio__inner {
    border-color: #2E8AF1;
    background: #2E8AF1;
}
.addTag-dialog .el-dialog__headerbtn:focus .el-dialog__close,.addTag-dialog .el-dialog__headerbtn:hover .el-dialog__close{
  color:#2E8AF1
}
.el-cascader-menu__item.is-active{
  color:#2E8AF1
}
</style>



// WEBPACK FOOTER //
// src/pages/workBench/components/addTagDialog.vue